import Vue from "vue";
import Router from "vue-router";
import Playground from "@/components/pages/Playground";
import LoginPage from "@/components/pages/LoginPage";
import HomePage from "@/components/pages/HomePage";
import ItineraryList from "../components/gt/itineraries/ItineraryList";
import SupplierList from "../components/gt/suppliers/SupplierList";
import ItineraryDetails from "../components/gt/itineraries/ItineraryDetails";
import ClientList from "../components/gt/clients/ClientList";
import ClientTitlesList from "../components/gt/clients/ClientTitlesList";
import ClientTypesList from "../components/gt/clients/ClientTypesList";
import ClientStatusesList from "../components/gt/clients/ClientStatusesList";
import AgentList from "../components/gt/agents/AgentList";
import AgentGroupsList from "../components/gt/agents/AgentGroupsList";
import AgentTypesList from "../components/gt/agents/AgentTypesList";
import SalesInvoiceList from "../components/gt/finances/sales-invoices/SalesInvoiceList";
import SalesInvoiceDetails from "../components/gt/finances/sales-invoices/SalesInvoiceDetails";
import PurchaseInvoicePaymentDetails from "../components/gt/finances/purchase-invoice-payments/PurchaseInvoicePaymentDetails";
import PurchaseInvoiceDetails from "../components/gt/finances/purchase-invoices/PurchaseInvoiceDetails";
import PurchaseInvoiceList from "../components/gt/finances/purchase-invoices/PurchaseInvoiceList";
import PaymentList from "../components/gt/finances/payments/PaymentList";
import PurchaseInvoicePaymentList from "../components/gt/finances/purchase-invoice-payments/PurchaseInvoicePaymentList";
import SupplierDetails from "../components/gt/suppliers/SupplierDetails";
import SupplierBooking from "../components/gt/suppliers/booking/SupplierBooking";
import ItineraryBuilder from "../components/gt/itineraries/builder/ItineraryBuilder";
import SupplierContents from "../components/gt/plugins/supplier-contents/SupplierContents";
import TemplateList from "../components/gt/templates/TemplateList";
import GroupTemplateList from "../components/gt/templates/GroupTemplateList";
import TemplateBuilder from "../components/gt/templates/builder/TemplateBuilder";
import GroupTemplateBuilder from "../components/gt/templates/builder/GroupTemplateBuilder";
import OpenGroupList from "../components/gt/open-groups/OpenGroupList";
import OpenGroupBuilder from "../components/gt/open-groups/OpenGroupBuilder";
import TemplateTypeList from "../components/gt/templates/template-types/TemplateTypeList";
import ClientEditor from "../components/gt/clients/ClientEditor";
import AgentEditor from "../components/gt/agents/AgentEditor";
import PaymentEditor from "../components/gt/finances/payments/PaymentEditor";
import AllDestinationsList from "../components/gt/admin/destinations/AllDestinationsList";
import TreeviewDestinations from "../components/gt/admin/destinations/TreeviewDestinations";
import PickupsList from "../components/gt/admin/destinations/PickupsList";
import CurrenciesList from "../components/gt/admin/currencies/CurrenciesList";
import ExchangeRatesList from "../components/gt/admin/currencies/ExchangeRatesList";
import TaxesList from "../components/gt/admin/currencies/TaxesList";
import PaymentTypesList from "../components/gt/admin/currencies/PaymentTypesList";
import RoomsList from "../components/gt/admin/service-types/RoomsList";
import StarsList from "../components/gt/admin/service-types/StarsList";
import ActivitiyTypesList from "../components/gt/admin/service-types/ActivitiyTypesList";
import TransportTypesList from "../components/gt/admin/service-types/TransportTypesList";
import TravelTypesList from "../components/gt/admin/service-types/TravelTypesList";
import OtherTypesList from "../components/gt/admin/service-types/OtherTypesList";
import PackageTypesList from "../components/gt/admin/service-types/PackageTypesList";
import ExtraTypesList from "../components/gt/admin/service-types/ExtraTypesList";
import AccommodationTypesList from "../components/gt/admin/service-types/AccommodationTypesList";
import BoardBasisTypesList from "../components/gt/admin/service-types/BoardBasisTypesList";
import NominalCodes from "../components/gt/admin/service-types/NominalCodes";
import ChargesTypesList from "../components/gt/admin/service-types/ChargesTypesList";
import RateTypesList from "../components/gt/admin/department-types/RateTypesList";
import ExportLogsList from "../components/gt/admin/logs/ExportLogsList";
import DepartmentsList from "../components/gt/admin/department-types/DepartmentsList";
import InternalStatusesList from "../components/gt/admin/department-types/InternalStatusesList";
import HeadOfficesList from "../components/gt/admin/department-types/HeadOfficesList";
import MandatoryChargesList from "../components/gt/admin/service-types/MandatoryChargesList";
import LanguagesList from "../components/gt/admin/languages/LanguagesList";
import TranslationsList from "../components/gt/admin/languages/TranslationsList";
import Admin from "../components/gt/admin/AdminPanel";
import ReportsList from "../components/gt/reports/ReportsList";
import DocumentsContents from "../components/gt/admin/contents/DocumentsContents";
import EmailsContents from "../components/gt/admin/contents/EmailsContents";
import OtherContents from "../components/gt/admin/contents/OtherContents";
import ItineraryContents from "../components/gt/admin/contents/ItineraryContents";
import GTTemplateImporter from "../components/gt/templates/GTTemplatesImporter";
import RatesImporter from "../components/gt/plugins/rates-importer/RatesImporter";
import HistoryList from "../components/gt/plugins/histories/HistoryList";
import TaskTrackerList from "../components/gt/plugins/task-tracker/TaskTrackerList";
import ItineraryScenarios from "../components/gt/itineraries/scenarios/ItineraryScenarios";
import MarkupList from "../components/gt/plugins/markups/MarkupList";
import BrandList from "../components/gt/plugins/brands/BrandList";
import ItineraryDocuments from "../components/gt/admin/contents/ItineraryDocuments";
import RoutesList from "../components/gt/admin/destinations/RoutesList";
import BusinessModelList from "../components/gt/admin/department-types/BusinessModelList";
import CommissionList from "../components/gt/plugins/commissions/CommissionList";
import FlightsList from "../components/gt/plugins/flights/FlightsList";
import TenantSetup from "../components/gt/admin/user-access-controls/TenantSetup";
import OwnerControls from "../components/gt/admin/user-access-controls/OwnerControls";
import PurchaseInvoiceApprovalList from "../components/gt/finances/pi-approvals/PurchasInvoiceApprovalList";
import SupplierItineraryNoteTypeList from "../components/gt/admin/supplier-itinerary-note-types/SupplierItiNoteTypeList";
import CustomDataTypes from "../components/gt/admin/cd-types/CustomDataTypes";

import TaskStatuses from "../components/gt/admin/tasks/TaskStatusList";
import TaskPriorities from "../components/gt/admin/tasks/TaskPriorityList";
import AllocationsPlugin from "../components/gt/plugins/allocations/AllocationsPlugin";
import EmailTypes from "../components/gt/admin/contents/EmailTypes";
import CircuitDiscountList from "../components/gt/plugins/circuit-discounts/CircuitDiscountList";
import PaymentMethods from "../components/gt/admin/payment-methods/PaymentMethods";
import GtAI from "../components/gt/plugins/gt-ai/GtAI";
import ThirdPartySetups from "../components/gt/plugins/third-party-setups/ThirdPartySetups";
import UserAccessSettings from "../components/gt/plugins/user-access-settings/UserAccessSettings";
import AvailableAccessSettings from "../components/gt/admin/available-access-settings/AvailableAccessSettings";
import ExternalFormsList from "../components/gt/shared/external-forms/ExternalFormsList.vue";
import ProcessLogs from "../components/gt/plugins/process-logs/ProcessLogs.vue";
import ResetPassword from "../components/pages/ResetPassword";
import LeadSourcesList from "../components/gt/admin/lead-sources/LeadSourcesList";
import { authGuard } from "./auth-guard";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/playground",
      component: Playground,
    },
    {
      path: "/",
      component: LoginPage,
    },
    {
      path: "/reset-password/:token?",
      component: ResetPassword,
    },
    {
      path: "/home",
      component: HomePage,
      beforeEnter: authGuard,
    },
    {
      path: "/itineraries",
      component: ItineraryList,
      beforeEnter: authGuard,
    },
    {
      path: "/reports",
      component: ReportsList,
      beforeEnter: authGuard,
    },
    {
      path: "/itinerary/:id/details",
      component: ItineraryDetails,
      beforeEnter: authGuard,
      name: "Itinerary Details",
    },
    {
      path: "/itinerary/new",
      component: ItineraryBuilder,
      beforeEnter: authGuard,
      name: "Itinerary Builder",
    },
    {
      path: "/itinerary/:id/edit",
      component: ItineraryBuilder,
      beforeEnter: authGuard,
      name: "Itinerary Edit",
    },
    {
      path: "/itinerary/:id/scenarios",
      component: ItineraryScenarios,
      beforeEnter: authGuard,
      name: "Itinerary Scenarios",
    },
    {
      path: "/suppliers/:supplierType",
      component: SupplierList,
      beforeEnter: authGuard,
    },
    {
      path: "/supplier/:id/details",
      component: SupplierDetails,
      beforeEnter: authGuard,
      name: "Supplier Details",
    },
    {
      path: "/supplier/:id/book",
      component: SupplierBooking,
      beforeEnter: authGuard,
      name: "Supplier Booking",
    },
    {
      path: "/supplier/new",
      component: SupplierDetails,
      beforeEnter: authGuard,
      name: "Supplier Create",
    },
    {
      path: "/client-types",
      component: ClientTypesList,
      beforeEnter: authGuard,
    },
    {
      path: "/client-titles",
      component: ClientTitlesList,
      beforeEnter: authGuard,
    },
    {
      path: "/client-statuses",
      component: ClientStatusesList,
      beforeEnter: authGuard,
    },

    {
      path: "/clients",
      component: ClientList,
      beforeEnter: authGuard,
    },
    {
      path: "/client/new",
      component: ClientEditor,
      beforeEnter: authGuard,
      name: "Client Builder",
    },
    {
      path: "/client/:id/edit",
      component: ClientEditor,
      beforeEnter: authGuard,
      name: "Client Edit",
    },
    {
      path: "/agent/new",
      component: AgentEditor,
      beforeEnter: authGuard,
      name: "Agent Builder",
    },
    {
      path: "/agent/:id/edit",
      component: AgentEditor,
      beforeEnter: authGuard,
      name: "Agent Edit",
    },
    {
      path: "/payment/:id/edit",
      component: PaymentEditor,
      beforeEnter: authGuard,
      name: "Payment Edit",
    },
    {
      path: "/sales-invoices",
      component: SalesInvoiceList,
      beforeEnter: authGuard,
    },
    {
      path: "/salesinvoice/:id/details",
      component: SalesInvoiceDetails,
      beforeEnter: authGuard,
      name: "Sales Invoice Details",
    },
    {
      path: "/purchase-invoices",
      component: PurchaseInvoiceList,
      beforeEnter: authGuard,
    },
    {
      path: "/purchase-invoice-payments",
      component: PurchaseInvoicePaymentList,
      beforeEnter: authGuard,
    },
    {
      path: "/purchaseinvoicepayment/:id/details",
      component: PurchaseInvoicePaymentDetails,
      beforeEnter: authGuard,
      name: "Purchase Invoice Payment Details",
    },
    {
      path: "/purchaseinvoice/:id/details",
      component: PurchaseInvoiceDetails,
      beforeEnter: authGuard,
      name: "Purchase Invoice Details",
    },
    {
      path: "/pi-approvals",
      component: PurchaseInvoiceApprovalList,
      beforeEnter: authGuard,
    },
    {
      path: "/receipts",
      component: PaymentList,
      beforeEnter: authGuard,
    },
    {
      path: "/supplier-contents",
      component: SupplierContents,
      beforeEnter: authGuard,
    },
    {
      path: "/history-list",
      component: HistoryList,
      beforeEnter: authGuard,
    },
    {
      path: "/task-tracker",
      component: TaskTrackerList,
      beforeEnter: authGuard,
    },
    {
      path: "/templates",
      component: TemplateList,
      beforeEnter: authGuard,
    },
    {
      path: "/group-templates",
      component: GroupTemplateList,
      beforeEnter: authGuard,
    },
    {
      path: "/open-groups",
      component: OpenGroupList,
      beforeEnter: authGuard,
    },
    {
      path: "/open-group/new",
      component: OpenGroupBuilder,
      beforeEnter: authGuard,
      name: "Open Group Builder",
    },
    {
      path: "/open-group/:id/edit",
      component: OpenGroupBuilder,
      beforeEnter: authGuard,
      name: "Open Group Edit",
    },
    {
      path: "/template-types",
      component: TemplateTypeList,
      beforeEnter: authGuard,
    },
    {
      path: "/template/new",
      component: TemplateBuilder,
      beforeEnter: authGuard,
      name: "Template Builder",
    },
    {
      path: "/group-template/new",
      component: GroupTemplateBuilder,
      beforeEnter: authGuard,
      name: "Group Template Builder",
    },

    {
      path: "/gt-importer",
      component: GTTemplateImporter,
      beforeEnter: authGuard,
      name: "GT Template Importer",
    },
    {
      path: "/rates-importer",
      component: RatesImporter,
      beforeEnter: authGuard,
      name: "Data Importer",
    },
    {
      path: "/template/:id/edit",
      component: TemplateBuilder,
      beforeEnter: authGuard,
      name: "Template Edit",
    },
    {
      path: "/group-template/:id/edit",
      component: GroupTemplateBuilder,
      beforeEnter: authGuard,
      name: "Group Template Edit",
    },
    {
      path: "/markups",
      component: MarkupList,
      beforeEnter: authGuard,
    },
    {
      path: "/commissions",
      component: CommissionList,
      beforeEnter: authGuard,
    },
    {
      path: "/flights-management",
      component: FlightsList,
      beforeEnter: authGuard,
    },
    {
      path: "/circuit-discounts",
      component: CircuitDiscountList,
      beforeEnter: authGuard,
    },
    {
      path: "/allocations-plugin",
      component: AllocationsPlugin,
      beforeEnter: authGuard,
    },
    {
      path: "/gt-ai",
      component: GtAI,
      beforeEnter: authGuard,
    },
    {
      path: "/third-party-setups",
      component: ThirdPartySetups,
      beforeEnter: authGuard,
    },
    {
      path: "/user-access-settings",
      component: UserAccessSettings,
      beforeEnter: authGuard,
    },
    {
      path: "/available-access-settings",
      component: AvailableAccessSettings,
      beforeEnter: authGuard,
    },
    {
      path: "/external-forms",
      component: ExternalFormsList,
      beforeEnter: authGuard,
    },
    {
      path: "/process-logs",
      component: ProcessLogs,
      beforeEnter: authGuard,
    },
    {
      path: "/head-offices",
      component: HeadOfficesList,
      name: "Head Offices List",
      beforeEnter: authGuard,
    },
    {
      path: "/agents",
      component: AgentList,
      beforeEnter: authGuard,
    },
    {
      path: "/agent-groups",
      component: AgentGroupsList,
      beforeEnter: authGuard,
    },
    {
      path: "/agent-types",
      component: AgentTypesList,
      beforeEnter: authGuard,
    },
    {
      path: "/admin",
      component: Admin,
      beforeEnter: authGuard,
      name: "Admin",
      children: [
        {
          path: "all-destinations",
          component: AllDestinationsList,
          name: "All Destinations List",
        },
        {
          path: "currencies",
          component: CurrenciesList,
          name: "Currencies",
        },
        {
          path: "exchange-rates",
          component: ExchangeRatesList,
          name: "Exchange Rates List",
        },
        {
          path: "taxes",
          component: TaxesList,
          name: "Taxes List",
        },
        {
          path: "rooms",
          component: RoomsList,
          name: "Rooms List",
        },
        {
          path: "activity-types",
          component: ActivitiyTypesList,
          name: "Activity Types List",
        },
        {
          path: "transport-types",
          component: TransportTypesList,
          name: "Transport Types List",
        },
        {
          path: "travel-types",
          component: TravelTypesList,
          name: "Travel Types List",
        },
        {
          path: "other-types",
          component: OtherTypesList,
          name: "Other Types List",
        },
        {
          path: "package-types",
          component: PackageTypesList,
          name: "Package Types List",
        },
        {
          path: "extra-types",
          component: ExtraTypesList,
          name: "Extra Types List",
        },
        {
          path: "accommodation-types",
          component: AccommodationTypesList,
          name: "Accommodation Types List",
        },
        {
          path: "board-basis-types",
          component: BoardBasisTypesList,
          name: "Board Basis Types List",
        },
        {
          path: "star-rating",
          component: StarsList,
          name: "Star Rating List",
        },
        {
          path: "nominal-codes",
          component: NominalCodes,
          name: "Nominal Codes",
        },
        {
          path: "charges-types",
          component: ChargesTypesList,
          name: "Charges Types List",
        },
        {
          path: "rate-types",
          component: RateTypesList,
          name: "Rate Types List",
        },
        {
          path: "export-logs",
          component: ExportLogsList,
          name: "Export Log List",
        },
        {
          path: "departments",
          component: DepartmentsList,
          name: "Departments List",
        },
        {
          path: "internal-statuses",
          component: InternalStatusesList,
          name: "Internal Statuses List",
        },

        {
          path: "brands",
          component: BrandList,
          beforeEnter: authGuard,
        },
        {
          path: "lead-sources",
          component: LeadSourcesList,
          name: "Lead Sources List",
          beforeEnter: authGuard,
        },
        {
          path: "business-models",
          component: BusinessModelList,
          beforeEnter: authGuard,
        },
        {
          path: "mandatory-charges",
          component: MandatoryChargesList,
          name: "Mandatory Charges List",
        },
        {
          path: "languages",
          component: LanguagesList,
          name: "Languages List",
        },
        {
          path: "translations",
          component: TranslationsList,
          name: "Translations List",
        },
        {
          path: "treeview-destinations",
          component: TreeviewDestinations,
          name: "Treeview Destinations",
        },
        {
          path: "pickups-list",
          component: PickupsList,
          name: "Pickups List",
        },
        {
          path: "payment-methods",
          component: PaymentMethods,
          name: "Payment Methods",
        },
        {
          path: "payment-types",
          component: PaymentTypesList,
          name: "Payment Types List",
        },
        {
          path: "documents-contents",
          component: DocumentsContents,
          name: "Documents Content",
        },
        {
          path: "itinerary-documents",
          component: ItineraryDocuments,
          name: "Itinerary Documents",
        },
        {
          path: "emails-contents",
          component: EmailsContents,
          name: "Emails Contents",
        },
        {
          path: "email-types",
          component: EmailTypes,
          name: "Email Types",
        },
        {
          path: "other-contents",
          component: OtherContents,
          name: "Other Contents",
        },
        {
          path: "itinerary-contents",
          component: ItineraryContents,
          name: "Itinerary Contents",
        },
        {
          path: "supplier-iti-note-types",
          component: SupplierItineraryNoteTypeList,
          name: "Supplier Itinerary Note Types",
        },
        {
          path: "custom-data-types",
          component: CustomDataTypes,
          name: "Custom Data Types",
        },
        {
          path: "routes",
          component: RoutesList,
          name: "Routes List",
        },
        {
          path: "tenant-setup",
          component: TenantSetup,
          name: "Tenant Setup",
        },
        {
          path: "owner-controls",
          component: OwnerControls,
          name: "Owner Controls",
        },
        {
          path: "task-statuses",
          component: TaskStatuses,
          beforeEnter: authGuard,
        },
        {
          path: "task-priorities",
          component: TaskPriorities,
          beforeEnter: authGuard,
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js